export const EventType = {
	INSTALL: 'OnAppSettingsInstall',
	CHANGE: 'OnAppSettingsChange',
	DISPLAY: 'OnAppSettingsDisplay',
};
